// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wH-z","hovered":"xH-z","hoverImage":"yH-z","mainImage":"zH-z","imageNoBackground":"AH-z","fullSizeImage":"BH-z"};